export default __webpack_public_path__ + "static/media/vtc-logo2.3bde24ac.png";